import React from 'react'
import './dealership-auto-coverage.scss'
import {
    Hero, MainHeading,
    Breadcrumb, CommonTabs,
    SentryCard, Plans,
    NewsCard, SuccessStories,
    FindAgent,
    PageHeaderIntro
} from '../../../../components';
import { images } from "../../../../utils/customFn";
import { Container } from 'react-bootstrap';

const DealershipAutoCoverage = () => {
    const breadcrumbs = [
        { label: "Sentry Insurance home", link: "/" },
        { label: "What we offer", link: "/what-we-offer" },
        { label: "Insurance products", link: "/what-we-offer/insurance-products" },
        { label: "Business auto insurance", link: "/what-we-offer/insurance-products/business-auto-insurance" },
        { label: "Dealership auto coverage", link: "/what-we-offer/insurance-products/business-auto-insurance/dealership-auto-coverage" },
    ];

    const activeTabId = "difference";

    const tabsData = [
        {
            id: "difference",
            href: "#/",
            label: "The Sentry difference",
        },
        {
            id: "coverages",
            href: "#/",
            label: "Insurance resources",
        },
        {
            id: "help",
            href: "#/",
            label: "Who we've helped",
        },
    ];

    const sectrydata = {
        banner: images['two_business_people_looking_at_tablet.avif'],
        heading: 'The Sentry difference',
        subheading: 'Different drivers—different coverages',
        para: 'We’ll work with you to determine what liability insurance coverage is appropriate for your organization. Our goal is to help make sure you’re protected from the actual exposures and risks your business faces.',
        sideheading: 'The right coverage for your business',
        sidepara: 'We draw on our insurance experience and leverage our industry knowledge to help you protect your business and your future.',
        sideImg: images['boots_Blue.svg']
    }
    const plansData = {
        blue_heading: 'Risk management solutions and personal service for your dealership',
        blue_para: 'At Sentry, we take a proactive approach to insurance. That means limiting losses and reducing risk by helping you create a safer company culture from the ground up. We offer a range of services that will help you make your dealership safer.',
        purple_icon: images['Icon_of_orange_clock.svg'],
        purple_heading: 'Flexible coverage options',
        purple_para: "We’ll work directly with you to help you choose the specific coverages that make sense for your dealership and your industry.",
    }
    const NewsCardData = [
        {
            id: 1,
            title: 'Commercial auto insurance',
            description:
                'We have the 401(k) and other retirement plan options and services to help you and your employees plan for retirement.',
            linkUrl: '',
            linkText: 'More about commercial auto insurance >',
        },
        {
            id: 2,
            title: 'Dealership auto coverage',
            description: 'Running a business comes with uncertainties. Protect yourself from the unknown with business liability coverage.',
            linkUrl: '/',
            linkText: 'More about dealership auto coverage >',
        },
        {
            id: 3,
            title: 'Commercial auto liability',
            description:
                'Protect your profits and property from the unexpected during a construction or renovation project.',
            linkUrl: '/',
            linkText: 'More about commercial auto liability >',
        },

    ];
    const HeaderData = [
        {
            image: images['Guidance_Telescope_Blue.svg'],
            para: 'We know dealerships like yours face unique exposures every day. Customers test-driving unfamiliar vehicles. A steady stream of employees and customers entering and exiting your property. Maintenance and safety for your inventory and service area. That’s why we offer industry-specific insurance plans: to help you protect your business from the risks you face, with the backing of a team that knows your industry. That means liability and physical damage policies, flexible coverage options, and direct access to our experienced claims team.',
        },
    ];
    return (
        <>
            <div className='dealership-auto-coverage'>
                {/* hero section */}
                <Hero img={images["New_cars_parked_in_line_at_dealership.avif"]} />
                <Container>
                    {/* Breadcrumb */}
                    <Breadcrumb crumbs={breadcrumbs} />
                    {/* heading  */}
                    <MainHeading title="Dealership auto coverage" showshare={false} />
                    {/* Tabs */}
                    <CommonTabs tabs={tabsData} activeTab={activeTabId} />

                    {/* Header intro section */}
                    <PageHeaderIntro Data={HeaderData} heading="" />

                    {/* the sentry card */}
                    {/* <SentryCard data={sectrydata} /> */}
                    {/* Plans section */}
                    <div className='the-sentry-card'>
                        <h1>The Sentry difference</h1>
                        <Plans data={plansData} />
                    </div>
                    {/* news card section */}
                    <NewsCard Title="Insurance resources for your dealership" CardData={NewsCardData} showNavLink={false} subTitle="PRODUCTS" />
                    {/* success stories */}
                    <SuccessStories showSeemore={true} />
                    {/* news  */}
                    <NewsCard Title="News and resources" CardData={NewsCardData} showNavLink={false} subTitle="GUIDES" />
                    <FindAgent />
                </Container>
            </div>
        </>
    )
}

export default DealershipAutoCoverage